package navigation.settings.general

import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val generalUiModule
    get() =
        module {
            factoryOf(::GeneralScreenModel)
        }